import { useAction } from '@src/redux/hooks/useAction';
import { useAsync } from '@src/redux/hooks/useAsync';
import { useSelect } from '@src/redux/hooks/useSelect';

import {
  SELECT_ADMIN,
  SET_UNKNOWN_PAA,
  SET_PHONE_NUMBER,
  RESET_STATE,
  SET_JOB_FUNCTIONS,
  SUBMIT_TIN_REQUEST,
  SET_PERMISSIONS,
} from './constants';

import {
  selectAdmin,
  setPhoneNumber,
  setUnknownPAA,
  resetState,
  setJobFunctions,
  submitTINRequest,
  setPermissions,
} from './actions';

const standardUserSelector = (state) => {
  return state.standardUser;
};

export const useStandardUserRegistration = {
  state: () => {
    return useSelect(standardUserSelector);
  },
  actions: () => {
    return {
      selectAdmin: useAction(selectAdmin, {
        saga: useAsync(SELECT_ADMIN),
      }),
      setJobFunctions: useAction(setJobFunctions, {
        saga: useAsync(SET_JOB_FUNCTIONS),
      }),
      setUnknownPAA: useAction(setUnknownPAA, {
        saga: useAsync(SET_UNKNOWN_PAA),
      }),
      setPhoneNumber: useAction(setPhoneNumber, {
        saga: useAsync(SET_PHONE_NUMBER),
      }),
      resetState: useAction(resetState, {
        saga: useAsync(RESET_STATE),
      }),
      submitTINRequest: useAction(submitTINRequest, {
        saga: useAsync(SUBMIT_TIN_REQUEST),
      }),
      setPermissions: useAction(setPermissions, {
        saga: useAsync(SET_PERMISSIONS),
      }),
    };
  },
};
